import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import { useTheme, ThemeContext } from '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-cards.css';
import { EGDSCardBackgroundThemes, EGDSCardTags, EGDSCardAspectRatios } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSCard = React.forwardRef((props, ref) => {
  const {
    backgroundTheme = EGDSCardBackgroundThemes.PRIMARY,
    border,
    children,
    className,
    overflow: initialOverflow,
    padded,
    placeholder,
    selected,
    useStandardCardPadding,
    tag,
    style,
    ...attributes
  } = props;
  let overflow = initialOverflow;
  let actionArea;
  let featuredHeader;
  let link;
  let placeholderChild;
  const newChildren = [];
  const Tag = tag && EGDSCardTags.get(tag) || EGDSCardTags.get('div');
  const childrenArray = React.Children.toArray(children);
  const {
    className: themeClasses,
    ...themeDataAttributes
  } = useTheme();
  const themeContext = React.useContext(ThemeContext);
  const isColorThemeContainer = themeContext?.color?.isColorThemeContainer;
  // Map through the children and place the ones we want in specific places
  React.Children.forEach(children, child => {
    if (!child) {
      return;
    }
    const displayName = child.type?.displayName;
    if (displayName === 'EGDSCarousel') {
      overflow = true;
    }
    switch (true) {
      case /(EGDS|Uitk)CardActionArea/.test(displayName):
        actionArea = child;
        break;
      case /(EGDS|Uitk)CardFeaturedHeader/.test(displayName):
        featuredHeader = child;
        break;
      case /(EGDS|Uitk)CardLink/.test(displayName):
        link = child;
        break;
      case /(EGDS|Uitk)CardPlaceholder/.test(displayName):
        placeholderChild = child;
        break;
      default:
        newChildren.push(child);
    }
  });
  const baseClass = 'uitk-card';
  const ratioClass = placeholder && EGDSCardAspectRatios.get(placeholder.aspectRatio);
  let paddedClassname;
  if (useStandardCardPadding && padded) {
    paddedClassname = `${baseClass}-standard-padded`;
  } else if (padded) {
    paddedClassname = `${baseClass}-padded`;
  } else {
    paddedClassname = '';
  }
  const isValidEGDSCardBackgroundTheme = value => Object.values(EGDSCardBackgroundThemes).includes(value);
  const backgroundClassFragment = backgroundTheme && isValidEGDSCardBackgroundTheme(backgroundTheme) ? backgroundTheme : EGDSCardBackgroundThemes.PRIMARY;
  const cssClassNames = getClassNameList(baseClass, `${baseClass}-roundcorner-all`, actionArea && `${baseClass}-has-action-area`, border && `${baseClass}-has-border`, placeholder && `${baseClass}-has-placeholder-border`, featuredHeader && `${baseClass}-has-featured-header`, link && `${baseClass}-has-link`, overflow && `${baseClass}-has-overflow`, paddedClassname, selected && `${baseClass}-selected`, !children && `${baseClass}-empty`, className, placeholder && `${baseClass}-${ratioClass}`, `${baseClass}-has-${backgroundClassFragment}-theme`, !isColorThemeContainer && themeClasses);
  if (placeholderChild) {
    return React.cloneElement(placeholderChild, {
      className: cssClassNames
    });
  }
  if (childrenArray.length > 1) {
    return jsxs(Tag, {
      className: cssClassNames,
      ...attributes,
      ...(!isColorThemeContainer && themeDataAttributes),
      ref: ref,
      style: style,
      children: [featuredHeader, newChildren, actionArea, link]
    });
  }
  if (childrenArray.length === 1) {
    const firstChild = childrenArray[0];
    const cardCustomStyleProps = {
      ...firstChild?.props?.style,
      ...style
    };
    const decoratedChild = React.cloneElement(firstChild, {
      className: classNames(cssClassNames, firstChild?.props?.className),
      ...attributes,
      ...(!isColorThemeContainer && themeDataAttributes),
      ...(Object.keys(cardCustomStyleProps).length !== 0 && {
        style: cardCustomStyleProps
      })
    });
    return decoratedChild;
  }
  return jsx(Tag, {
    className: cssClassNames,
    ...attributes,
    ...(!isColorThemeContainer && themeDataAttributes),
    ref: ref,
    style: style
  });
});
EGDSCard.displayName = 'EGDSCard';
// Temporary, unstable
const EGDSCardAloha = EGDSCard;
export { EGDSCard, EGDSCardAloha };